const mergeTicketClasses = (pages) => {
    if (!pages) {
        return pages;
    }
    let ticketClasses = [];

    for (let i = 0; i < pages.length; i++) {
        const page = pages[i];

        if (page && page['ticket_classes']) {
            ticketClasses = [...ticketClasses, ...page['ticket_classes']];
        }
    }
    return {
        ticket_classes: ticketClasses,
    };
};

const mergeAttendees = (pages) => {
    if (!pages) {
        return pages;
    }
    let attendees = [];

    for (let i = 0; i < pages.length; i++) {
        const page = pages[i];
        if (page && page.attendees) {
            attendees = [...attendees, ...page.attendees];
        }
    }
    return {
        attendees,
    };
};

const mergeTaxOptions = (pages) => {
    if (!pages) {
        return pages;
    }
    let taxOptions = [];

    for (let i = 0; i < pages.length; i++) {
        const page = pages[i];
        let {
            pagination: { object_count: objectCount },
        } = pages[i];
        if (page && page.tax_options) {
            while (objectCount) {
                taxOptions = [
                    ...taxOptions,
                    { ...page.tax_options[objectCount - 1] },
                ];
                objectCount--;
            }
        }
    }
    return taxOptions;
};

export default {
    mergeTicketClasses,
    mergeAttendees,
    mergeTaxOptions,
};
